import Swiper from 'swiper/swiper-bundle';
function testimonialSlider() {    

    var testimonialSlider = new Swiper(".testimonial-slider", {
        spaceBetween: 0,
        speed: 500,
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
    });
}

export default testimonialSlider;

//module.exports = bannerSlider;